/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react';
import { Close, IconColors, Success } from '../../Icons';
import styles from './global-messages.module.css';

interface SuccessMessageProps {
    primaryMessage: string;
    secondaryMessage?: string;
    dismiss: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function SuccessMessage({
    dismiss,
    primaryMessage,
    secondaryMessage,
}: SuccessMessageProps): React.ReactElement<SuccessMessageProps> {
    return (
        <div className={`${styles.MessagePanel} ${styles.SuccessMessage}`}>
            <Success color={IconColors.SucccessGreen} aspect="1.75rem" />
            <div className={styles.MessagePanelInfo} data-qa={`dispatch-success-${primaryMessage}`}>
                <p>{primaryMessage}</p>
                {!!secondaryMessage && <p>{secondaryMessage}</p>}
            </div>
            <div className={styles.MessagePanelClose} onClick={dismiss}>
                <Close aspect="1.25rem" color={IconColors.SucccessGreen} />
            </div>
        </div>
    );
}

export default SuccessMessage;
